import { useState, useEffect } from "react";

/**
 * Hook para detectar si la PWA es instalable y mostrar botón "Agregar al inicio".
 * En Chrome/Edge: usa beforeinstallprompt.
 * En Safari iOS: beforeinstallprompt no existe; mostramos instrucciones.
 */
export function usePWAInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOSDevice = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    setIsIOS(isIOSDevice);

    const isStandalone = window.matchMedia("(display-mode: standalone)").matches
      || window.navigator.standalone === true;
    setIsInstalled(isStandalone);

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setIsInstallable(false);
      setDeferredPrompt(null);
      return true;
    }
    return false;
  };

  const installInstructions = "Para agregar al inicio: toca el botón Compartir (cuadrado con flecha) y luego 'Agregar a pantalla de inicio'.";

  return {
    isInstallable: isInstallable && !isInstalled,
    isIOS,
    isInstalled,
    install,
    installInstructions
  };
}
